import { render, staticRenderFns } from "./BlackoutSettings.vue?vue&type=template&id=aaecd352&scoped=true"
import script from "./BlackoutSettings.vue?vue&type=script&lang=js"
export * from "./BlackoutSettings.vue?vue&type=script&lang=js"
import style0 from "./BlackoutSettings.vue?vue&type=style&index=0&id=aaecd352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaecd352",
  null
  
)

export default component.exports